import { z } from "zod"
import { EventEditScopeSchema } from "@mimber/schema"

export const DeleteEventFormSchema = z.object({
  scope: EventEditScopeSchema,
})

export type DeleteEventFormValues = z.infer<typeof DeleteEventFormSchema>
